import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';
import type { PropertyTaxData } from '@/pages/tax/routes/TaxWorkflow/types/tax-process.type';

export type DealClientDto = {
  hubspotId?: string | null;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string | null;
};

export type DealOwnershipDto = {
  clientName: string;
  clientEmail?: string;
  ownershipPercent: number | null;
};

export type DealPropertyDto = {
  propertyLocation: string;
  firstRentalDate?: string | null;
  saleDate?: string | null;
  purchaseDate?: string | null;
  subUrb: string;
  state: string;
  postCode: string | null;
  ownerships: DealOwnershipDto[];
};

export type { PropertyTaxData };

export type YearPropertyDto = {
  year: number;
  property: PropertyTaxData[];
};

export type ExtractSheetDto = {
  clients: DealClientDto[];
  properties: DealPropertyDto[];
  yearly: YearPropertyDto[];
};

export const taxWorkbookApi = createApi({
  reducerPath: 'taxWorkbookApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    extractSheet: builder.query<ExtractSheetDto, string>({
      query: (sheetId) => `/v1/tax/workbook/extract-sheet/${sheetId}`,
      transformResponse: (res: { data: ExtractSheetDto }) => res.data,
    }),
  }),
});

export const { useLazyExtractSheetQuery } = taxWorkbookApi;
